export const OPEN_LEAD_MAILER_WITH_CLIENT_DATA =
  'OPEN_LEAD_MAILER_WITH_CLIENT_DATA';
export const OPEN_LEAD_MAILER_WITH_CLIENT_DATA_SUCCESS =
  'OPEN_LEAD_MAILER_WITH_CLIENT_DATA_SUCCESS';
export const OPEN_LEAD_MAILER_WITH_CLIENT_DATA_FAILURE =
  'OPEN_LEAD_MAILER_WITH_CLIENT_DATA_FAILURE';

export const openLeadMailerWithClientData = () => ({
  type: OPEN_LEAD_MAILER_WITH_CLIENT_DATA,
});
